export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idpago: 0,
        idcredito: 0,
        dias_atraso: 0,
        identificador: 'CRED00',
        nombre:  '',
        dpi: '',
        telefono: '',
        email: '',
        direccion: '',
        idcredito: 0,
        cuota_pagar: 0,
        mora: 0,
        saldo_cuota_anterior: 0,
        total_pagar: 0,
        total_abonado: 0,
        total_restante: 0,
        pago_dias_atraso: 0,
        interes_mora: 0,
        total_mora: 0,
        total_creditos: 0,
        total_gastos_juridicos: 0,
        total_gastos_admin: 0,
        suma_total_pagar: 0,
    }

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        idmovimiento: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        clean_deposito_monto: 0,
        deposito_dolares: '',
        clean_deposito_dolares: 0,
        deposito_quetzales: '',
        clean_deposito_quetzales: 0,
        deposito_observaciones: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
        { value: 'REVERTIDO', label: 'REVERTIDO' },
    ];



    return Object.freeze({
        defaultFormGlobal,
        defaultDataModal,
        defaultFormDeposit,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
    })
}